import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./assests/languages/en.json";
import hiTranslation from "./assests/languages/hi.json";
import frTranslation from "./assests/languages/fr.json";
import knTranslation from "./assests/languages/kn.json";
import mlTranslation from "./assests/languages/ml.json";
import ruTranslation from "./assests/languages/ru.json";
import taTranslation from "./assests/languages/ta.json";
import teTranslation from "./assests/languages/te.json";
import baTranslation from "./assests/languages/ba.json";
import guTranslation from "./assests/languages/gu.json";
import maTranslation from "./assests/languages/ma.json";

const resources = {
  en: {
    translation: enTranslation.translation,
  },
  hi: {
    translation: hiTranslation.translation,
  },
  fr: {
    translation: frTranslation.translation,
  },
  kn: {
    translation: knTranslation.translation,
  },
  ml: {
    translation: mlTranslation.translation,
  },
  ru: {
    translation: ruTranslation.translation,
  },
  ta: {
    translation: taTranslation.translation,
  },
  te: {
    translation: teTranslation.translation,
  },
  ba: {
    translation: baTranslation.translation,
  },
  gu: {
    translation: guTranslation.translation,
  },
  ma: {
    translation: maTranslation.translation,
  },
  // Add more languages as needed
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    //debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: resources,
  });

export default i18n;
